"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var styles = function styles(_ref) {
  var type = _ref.type;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:fixed;", type !== 'top' && "\n    bottom: 10px;\n    left: 10px;\n  ", "\n  ", type === 'top' && "\n    top: 10px;\n  ", "\n  right:0;left:0;text-align:center;z-index:10000;pointer-events:none;")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-kxevlz0"
})(styles));

exports.default = _default;